export enum IdentityVerificationStatus {
  None = 'none',
  Pending = 'new',
  Rejected = 'rejected',
  Banned = 'banned',
  Accepted = 'accepted'
}

export type VerificationRejectType = 'manual' | 'similar' | 'auto';
export type ApplicantStatus = 'init' | 'pending' | 'onHold' | 'completed';

export interface IdentityVerificationResponse {
  status: IdentityVerificationStatus;
  applicantStatus?: ApplicantStatus;
  last_history?: IdentityVerificationHistory;
  rejectType?: VerificationRejectType;
  reason?: string;
}

export interface IdentityVerificationHistory {
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  isAuto: boolean;
  managerId: number;
}

export interface IdentityVerificationSettings {
  type: 'manual' | 'auto';
  auto?: {
    accessToken: string;
    countryCode: string;
  }
}
